// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3a3i-","tabsBox":"styles_tabsBox__3XNVm","createButton":"styles_createButton__3DgIY"};